/* eslint-disable no-unused-vars */
import { requestFail } from '@/store/actions/common.action'
import { getErrorStr } from '@/store/sagas/table.saga'
import { Drawer, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { getReviewLog } from '@/services/progress.service'
import Title from 'antd/lib/typography/Title'
import moment from 'moment'
import DiffComp from './component/diffComponent'


interface IColumnData {
    key: number;
    id: number;
    time: string;
    name: string;
    details: string;
}

interface IProps {
    open: boolean;
    data: any;
    setDrawerOpen: (value: boolean) => void;
    id: number | string | undefined;
}

function ReviewLogs(props: IProps): ReactElement {
    const { open, setDrawerOpen, id, data } = props
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const [tableList, setTableList] = useState<IColumnData[] | []>([])
    const [tableLoading, setTableLoading] = useState(false)
    const [formDataObj, setFormDataObj] = useState<any>({})

    const [pageNo, setPageNo] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [total, setTotal] = useState(0)



    const onClose = () => {
        setDrawerOpen(false)
    }

    const { Text } = Typography

    const getTableData = async (pageNo: number, pageSize: number) => {
        try {
            if (tableLoading || !id) return
            setTableLoading(true)
            const res = await getReviewLog({ id: String(id), pageNo: String(pageNo), pageSize: String(pageSize) })
            setTableList(res.content)
            setTotal(res.totalElements)
        } catch (e: any) {
            const str = getErrorStr(e)
            dispatch(requestFail(str))
        } finally {
            setTableLoading(false)
        }
    }

    useEffect(() => {
        getTableData(pageNo, pageSize)
    }, [id])

    const handleViewDiff = async (record: IColumnData) => {
        console.log(JSON.parse(record.details))
        setFormDataObj({
            ...record,
            changeFields: record.details
        })
    }

    // 封装拼接字符串的函数
    const joinTranslatedStrings = (...translations: string[]) =>
        translations.join(i18n.language !== 'zh' ? ' ' : '')

    const columns: ColumnsType<IColumnData> = [
        {
            title: t('version'),
            dataIndex: 'version',
            key: 'version',
            render: (_, record, idx) => {
                return (
                    <span>{tableList.length - idx}</span>
                )
            },
            width: 100,
        },
        {
            title: joinTranslatedStrings(t('Action'), t('name')),
            dataIndex: 'creator',
            key: 'creator',
            render: (text) => <a>{text}</a>,
        },
        {
            title: joinTranslatedStrings(t('Action'), t('time')),
            dataIndex: 'createTime',
            key: 'createTime',
            render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: t('Action'),
            key: 'action',
            render: (_, record: IColumnData) => (
                <Text
                    className="txt_blue hand"
                    title={t('view')}
                    onClick={() => handleViewDiff(record)}
                >
                    {t('view')}
                </Text>
            ),
        },
    ]

    return (
        <Drawer
            width={640}
            title={t('review log records')}
            placement="right"
            onClose={onClose}
            visible={open}
        >
            <div>
                <Title level={5}>
                    {data.proposalName}
                </Title>
                <Table
                    bordered
                    scroll={{ x: 'max-content' }}
                    rowKey="id"
                    loading={tableLoading}
                    dataSource={tableList}
                    columns={columns}
                    pagination={{
                        total,
                        current: pageNo,
                        pageSize,
                        onChange: (page, pageSize) => {
                            setPageNo(page)
                            setPageSize(pageSize)
                            getTableData(page, pageSize)
                        },
                    }}
                />
                <div style={{ marginTop: 16 }}>
                    {formDataObj && <DiffComp record={data} dataObj={formDataObj} />}
                </div>
            </div>
        </Drawer>
    )
}

export default ReviewLogs
